import {enableProdMode, importProvidersFrom} from '@angular/core';
import {environment} from './environments/environment';
import {AppComponent} from './app/app.component';
import {WizardApplicationModule} from './app/application/wizard-application.module';
import {GlobalModule} from './app/_global/global.module';
import {ToastrModule} from 'ngx-toastr';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {OAuthModule} from 'angular-oauth2-oidc';
import {FmcElementsModule} from '../firstmac-material-lib/projects/fmc-elements/src/lib/fmc-elements.module';
import {appRoutes} from './app/routes';
import {provideRouter} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {BrowserModule, bootstrapApplication} from '@angular/platform-browser';
import {ErrorHandlingInterceptor} from './app/interceptors/error-handling.interceptor';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import {VxService} from './app/services/vx.service';
import {ControlRequiredPipe} from './app/_global/pipes/control-required.pipe';
import {DataHandlerService} from './app/services/data-handler.service';
import {CanDeactivateGuard} from './app/_global/guards/can-deactivate.guard';
import {BehaviorService} from './app/services/behavior.service';
import {PartialResolverService} from './app/services/partial.resolver';
import {
  HttpErrorHandlerService,
  LookupService,
  FormBuilderService,
  ApplicationService,
  NotificationService,
  SubmissionService,
  TypesService,
  ProductService,
  ClientService,
  CollateralService,
  WorkbookService,
  CommunicationService,
  SalesService,
  FileService,
  RateService, ContactService, ApplicationMappingService
} from './app/services';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {
  UndefinedRequestInterceptor
} from '../firstmac-material-lib/projects/fmc-elements/src/lib/http-interceptors/undefined-request.interceptor';
import {VxCoreService} from './app/services/vx-core.service';


if (environment.production) {
  enableProdMode();
}

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: UndefinedRequestInterceptor, multi: true },
  // { provide: HTTP_INTERCEPTORS, useClass: ErrorHandlingInterceptor, multi: true }
];

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      MatSnackBarModule,
      FormsModule,
      FmcElementsModule.forRoot(environment),
      OAuthModule.forRoot(),
      NgbModule,
      ToastrModule.forRoot(),
      GlobalModule.forRoot(),
      WizardApplicationModule.forRoot()
    ),
    HttpErrorHandlerService,
    LookupService,
    FormBuilderService,
    ApplicationService,
    NotificationService,
    SubmissionService,
    TypesService,
    ProductService,
    ClientService,
    CollateralService,
    WorkbookService,
    CommunicationService,
    SalesService,
    RateService,
    PartialResolverService,
    BehaviorService,
    CanDeactivateGuard,
    DataHandlerService,
    ControlRequiredPipe,
    ContactService,
    VxService,
    FileService,
    ApplicationMappingService,
    VxCoreService,
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(appRoutes),
    httpInterceptorProviders,
  ]
})
  .catch(err => console.log(err));
